import { CustomSnackBarService } from "../shared/components/custom-snack-bar/custom-snack-bar.service";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { MenuItemButton } from '../shared/components/sidemenu/models/buttons/menu-item-button';
import { AuthService } from "../services/auth/auth.service";
import { GlobalVariables } from "../shared/utils/global-variables.service";

@Injectable()
export class AuthGuard  {
  constructor(
    private authService: AuthService,
    private router: Router,
    private snackBar: CustomSnackBarService,
    private globalVariables: GlobalVariables,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    

    return this.authService.isLoggedIn.pipe(
      take(1),

      map((isLoggedIn: boolean) => { 

        if (next.routeConfig === null || next.routeConfig.path === null) return false;

        var menuItemButton:MenuItemButton | undefined = this.verificaEstruturaMenu(this.authService.retornaEstruturaMenu(), next.routeConfig.path );

        if ((!menuItemButton) && 
             (next.routeConfig != null) &&
             (next.routeConfig.path != null) &&
             (next.routeConfig.path != "home") && 
             (next.routeConfig.path != "muda-senha") &&
             (next.routeConfig.path != "nova-senha") &&
             (next.routeConfig.path.length != 0))
        {
          this.snackBar.openSnackBar(
            "Você Não Tem Permissão de Acesso a Esta Página",
            null,
            "Warn"
          );
          this.router.navigate(["/home"]);
          return false;
        }      

        if (!isLoggedIn &&  next.routeConfig!= null && next.routeConfig.path != "nova-senha"){   
          var urlAtual = this.router.url;
          this.authService.logout(urlAtual);       
          return false;
        }
        
        if (this.authService.isTokenExpired()) {
          var urlAtual = this.router.url;
          this.authService.logout(urlAtual);
          this.snackBar.openSnackBar(
            "Sua sessão expirou, faça o login novamente.",
            null,
            "Warn"
          );
          return false;
        }

        if (menuItemButton)
        {
          this.globalVariables.telaAtiva = menuItemButton.label;
          this.globalVariables.telaDetalheAtiva = "";
        }
        
        return true;
      })
    );
  }

  private verificaEstruturaMenu(menuItems: any, link: string | undefined):MenuItemButton | undefined
  {
    var menuItemButton:MenuItemButton | undefined = undefined;
    if (menuItems != undefined)
    { 
      menuItemButton = <MenuItemButton> menuItems.filter(menuItem => menuItem.link == link)[0];
      if (menuItemButton=== undefined)
      {
        menuItems.forEach(element => {

          if (menuItemButton===undefined && element.items!=undefined)
            menuItemButton = element.items.filter(menuItem => menuItem.link === link)[0];

          if (menuItemButton===undefined && element.items!=undefined)
            menuItemButton = element.items.filter(menuItem => menuItem.link === element.id + "/" + link)[0];

        })
      }
    }
    
    return menuItemButton;
  }
}
